import {FIND_PHARMACY} from "../pharmacyTypeDefs";
import {useLazyQuery} from "@apollo/client";

export const useQueryFindPharmacy = (options?: any): any => (
  useLazyQuery(FIND_PHARMACY, options)
);
